import { ProcedureDetail, Status } from "./types";

export const initializeProcedure = (): ProcedureDetail => {
  return {
    jurisdiction: {
      organizationId: "",
    },
    procedureTags: [],

    name: "",
    summary: "",

    regions: [],

    acceptAppOnline: false,
    acceptAppByMail: false,
    acceptAppInPerson: false,
    acceptIssueAtStore: false,

    contentStatus: Status.Draft,
  };
};
